import CloseIcon from "@mui/icons-material/Close";
import type { AlertColor } from "@mui/material/Alert/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import { useState } from "react";

import { OpsCredentialsForm } from "../Form/OpsCredentialsForm";

interface OpsCredentialsDialogProps {
  open: boolean;
  onClose: () => void;
  practices: PracticeMessage[];
  credential?: OpsCredentialsMessage | null;
  afterSubmit: () => void;
  updateSnackBar: (snackbar: { severity: AlertColor; message: string }) => void;
}

export function OpsCredentialsDialog({
  open,
  onClose,
  practices,
  credential = null,
  afterSubmit,
  updateSnackBar,
}: OpsCredentialsDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          maxWidth: "735px",
          width: "100%",
          padding: "24px 36px",
          margin: "auto",
          borderRadius: "12px",
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ color: "#475467" }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <OpsCredentialsForm
          practices={practices}
          credential={credential}
          cancel={onClose}
          afterSubmit={() => {
            afterSubmit();
            onClose();
          }}
          updateSnackBar={updateSnackBar}
        />
      </DialogContent>
    </Dialog>
  );
}

OpsCredentialsDialog.defaultProps = {
  credential: null,
};

interface AddOpsCredentialButtonProps {
  practices: PracticeMessage[];
  afterSubmit: () => void;
  updateSnackBar: (snackbar: { severity: AlertColor; message: string }) => void;
}

export function AddOpsCredentialButton({
  practices,
  afterSubmit,
  updateSnackBar,
}: AddOpsCredentialButtonProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="contained" onClick={() => setOpen(true)}>
        Add Credential
      </Button>
      <OpsCredentialsDialog
        open={open}
        onClose={() => setOpen(false)}
        practices={practices}
        afterSubmit={afterSubmit}
        updateSnackBar={updateSnackBar}
      />
    </>
  );
}
